import CreateOrConnectHelper from '@/Utility/Association/CreateOrConnectHelper';
import ComponentManager from '@/Management/ComponentManager';

export default class ObjectCreationHelper extends CreateOrConnectHelper {

    public CreationCallback: Function;

    public constructor(params: any) {
        super(params);

        this.CreationCallback = this.handlerOrDefault(params.creationCallback);

        this.disconnectionCallback = this.CallCreationCallback;
        this.ExecuteAction = this.CallCreationCallback;
    }

    private CallCreationCallback(): void {
        this.CreationCallback();
        this.state('Finished');
    }
}

ComponentManager.setUtility('ObjectCreationHelper', ObjectCreationHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');